import React, { Component, useRef,useState } from 'react';
import { Link } from 'react-router-dom';
import "./signup-page.css";
import { collection, addDoc } from "firebase/firestore";
import db from '../../config/firebase';
import { async } from '@firebase/util';

const SignupPage = () => {
    const emailInput = useRef(null);
    const nameInput = useRef(null);
    const userOption = useRef(null);
    const userState = useState(false)
    const handleSubmit = (event) => {
        event.preventDefault();
        uploadUserData();
    }

    async function uploadUserData() {

        try {
            const docRef = await addDoc(collection(db, "users"), {
                name:nameInput.current.value,
                email:emailInput.current.value,
                role:userOption.current.value
            }).then(
                alert("Registered Successfully")
            )
            console.log("Document written with ID: ", docRef.id);
            // history.pushState('/');
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    return (
        <div className='register-form'>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Name"
                    required
                    ref={nameInput}
                />
                <br></br>

                <input
                    type="email"
                    placeholder="example@web.com"
                    required
                    ref={emailInput}
                >
                </input>
                <br></br>
                <select ref={userOption}>
                    <option value="User"> User
                    </option>
                    <option value="Beta Tester"> Beta Tester
                    </option>
                    <option value="Developer"> Developer
                    </option>
                </select>
                <br></br>
                <input type='submit' className='register-button' name='Register' />
            </form>
        </div>
    );

}

export default SignupPage;